import { SxProps } from '@mui/material/styles';
import React from 'react';
import { Stack } from 'src/components/Stack';

interface SectionToolbarProps {
  children: React.ReactNode;
  sx?: SxProps;
}
export const SectionToolbar: React.FC<SectionToolbarProps> = ({
  sx,
  children,
}) => {
  return (
    <Stack
      direction="row"
      alignItems="center"
      justifyContent="flex-start"
      flexWrap="wrap"
      spacing={2}
      sx={[{ p: 2 }, ...(Array.isArray(sx) ? sx : [sx])]}
    >
      {children}
    </Stack>
  );
};
